import {
  CircularProgress, FormControl, Radio, RadioGroup,
} from '@material-ui/core/';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {
  inject, observer,
} from 'mobx-react';
import React from 'react';
import {
  DefaultLanguage, languageCodes,
} from '../../constants/languages';
import GalleryField from '../../components/GeneralCRUDComponent/FormFields/GalleryField/GalleryField';
import SearchFilterDropdown from '../../components/SearchFilterComponent/SearchFilterDropdown';
import classes from './styles.module.scss';
import XLSX from 'xlsx';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import { translate } from 'helperFunctions/translation';
import {
  Props,
  State,
  NotificationType,
  NotificationScheduleType,
} from './types';
import { ICountry } from 'mobx-store/storeInterfaces/authInterface';
import { countriesIsoCodes } from 'constants/countries';
import ConfirmNotification from 'components/modals/confirmNotification/confirmNotification';
import {
  NotificationsChannel
} from '../../mobx-store/storeInterfaces/notificationInterface';
import { WheelEvent } from 'mobx-store/storeInterfaces/wheelFortuneInterface';
import NotificationBatches from './NotificationBatches';
import NotificationSchedule from './NotificationSchedule';

import { NotificationBatch } from './NotificationBatches/types';

@inject('authStore')
@inject('notificationStore')
@inject('bannerAdsStore')
@inject('academiesStore')
@inject('branchStore')
@inject('countryStore')
@inject('eventStore')
@inject('wheelFortuneStore')
@observer
class AddNotification extends React.Component<Props, State> {
  searchFilterDropdown: any;

  nativeMethodScreen: any;

  typeFilterDropDown: any;

  internalNavigationType: any;

  internalNavigationItemsDropDown: any;

  channelsTypes: any;

  isEgypt: boolean = false;

  batches: NotificationBatch [] = [];
  sendTime: string = '';

  constructor(props: Props) {
    super(props);
    this.state = ({
      notificationTitleEn: '',
      notificationTitleAr: '',
      notificationBodyEn: '',
      notificationBodyAr: '',
      status: 'all',
      imageEn: [],
      imageAr: [],
      file: [],
      link: '',
      type: 'static',
      internalNavigationType: null,
      internalNavigationItemId: -1,
      navigationItems: [],
      fileData: '',
      hideTitle: false,
      loadingCountry: true,
      open: false,
      notificationChannel: 'main-channel',
      notificationScheduleType: NotificationScheduleType.NOW,
      triedToSubmit: false,
      nativeModuleMethodName: '',
      nativeModuleName: '',
    });
  }

  selectSearchChange(newFilter: any) {
    this.setState({
      status: newFilter,
    });
  }

  changeShowTitleState(hideTitle: boolean) {
    this.setState({
      hideTitle,
    })
  }

  selectTypeChange(newFilter: string) {
    this.setState({
      type: newFilter,
    });
  }

  async selectInternalNavigationTypeChange(newFilter: string) {
    await this.setState({
      internalNavigationType: newFilter,
    });
    this.getNavigationItems();
  }

  selectInternalNavigationItemChange(newFilter: number) {
    this.setState({
      internalNavigationItemId: newFilter,
    });
  }


  getNativeMethodScreen = () => {
    return [{ value: 'test', name: 'test' }]
  }
  getArticleSearchFilterDropDown = () => {
    let filters = [
      {
        value: 'all', name: 'all',
      },
      {
        value: 'members', name: 'members',
      },
      {
        value: 'nonmembers', name: 'nonmembers',
      },
      {
        value: 'group', name: 'Group Notification',
      }
    ];
    if (!this.isEgypt) {
      filters = [
        {
          value: 'nonmembers', name: 'nonmembers',
        }
      ]
    }
    const sendTo = {
      value: this.state.status,
      onChange: this.selectSearchChange.bind(this),
      filters,
    }
    return sendTo;
  };

  getTypeFilterDropDown = () => ({
    value: this.state.type,
    onChange: this.selectTypeChange.bind(this),
    filters: [{
      value: 'static', name: 'static',
    },
    {
      value: 'internal', name: 'internal',
    },
    {
      value: 'external', name: 'external',
    },
      {
        value: 'native', name: 'native',
      },
    ],
  });

  getInternalNavigationTypeFilterDropDown = () => ({
    value: this.state.internalNavigationType,
    onChange: this.selectInternalNavigationTypeChange.bind(this),
    filters: this.getInternalNotificationOptions(),
  });

  getInternalNotificationOptions = () => {
    let options = [
      {
        value: 'home', name: 'Home Page',
      },
      {
        value: 'referral', name: 'Referral',
      },
      {
        value: 'requestCall', name: 'Request a Call',
      },
      {
        value: 'partner', name: 'Partner',
      },
      {
        value: 'offer', name: 'Offer',
      },
      {
        value: 'PartnersPage', name: 'Partners Page',
      },
      {
        value: 'offersPage', name: 'Offers Page',
      },
      {
        value: 'academy', name: 'Academy',
      },
      {
        value: 'branch', name: 'Branch',
      },
      {
        value: 'trophy', name: 'Trophy',
      },
      {
        value: 'renewal', name: 'Renewal',
      },
      {
        value: 'WHEEL_OF_FORTUNE', name: 'Wheel of fortune'
      },
      {
        value: 'SRS', name: 'Sports reservations'
      },
      {
        value: 'Travel', name: 'Travel'
      },
      {
        value: 'Loyalty_Program', name: 'Loyalty_Program'
      },
      {
        value: 'E_Ticketing', name: 'E_Ticketing'
      },
      {
        value: 'News', name: 'News'
      },

    ];
    if (!this.isEgypt) {
      options = [
        {
          value: 'home', name: 'Home Page',
        },
        {
          value: 'requestCall', name: 'Request a Call',
        },
        {
          value: 'academy', name: 'Academy',
        },
        {
          value: 'branch', name: 'Branch',
        },
        {
          value: 'event', name: 'Event',
        }
      ];
    }
    return options;
  };

  getNotficationChannelsTypes = () => ({
    value: this.state.notificationChannel,
    onChange: this.changeNotificationChannel.bind(this),
    filters: [...NotificationsChannel.possibleValues.map((channel) => {
      return {
        value: channel.id,
        name: channel.name,
      };
    })],
  });

  changeNotificationChannel(value: string) {
    this.setState({
      notificationChannel: value,
    })
  }

  getInternalNavigationItemsFilterDropDown = () => ({
    value: this.state.internalNavigationItemId,
    onChange: this.selectInternalNavigationItemChange.bind(this),
    filters: this.state.navigationItems,
  });

  getNavigationItems = async () => {
    const {
      branchStore,
      countryStore,
      academiesStore,
      bannerAdsStore,
      authStore,
    } = this.props;
    // empty entity list before choosing another
    this.setState({
      navigationItems: [],
    })
    switch (this.state.internalNavigationType) {
      case 'partner':
        await bannerAdsStore!.getDeglawyPartners(languageCodes.english);
        this.setState({
          navigationItems: this.structurePartnersNavigationItems(this.props.bannerAdsStore!.entityList),
        });
        break;
      case 'offer':
        await this.props.bannerAdsStore!.getDeglawyOffers(languageCodes.english);
        this.setState({
          navigationItems: this.structurePartnersNavigationItems(this.props.bannerAdsStore!.entityList),
        });
        break;
      case 'academy':
        await academiesStore!.getAcademies(countryStore!.managedCountries);
        this.setState({
          navigationItems: this.structureAcademiesNavigationItems(academiesStore!.academiesList),
        });
        break;
      case 'branch':
        await branchStore!.getBranches(countryStore!.managedCountries);
        this.setState({
          navigationItems: this.structureBranchesNavigationItems(this.props.branchStore!.branchesList),
        });
        break;
      case 'trophy':
        await bannerAdsStore!.getDeglawyTrophies(DefaultLanguage);
        this.setState({
          navigationItems: this.structurePartnersNavigationItems(this.props.bannerAdsStore!.entityList),
        });
        break;
      case 'event':
        await this.props.eventStore!.getEvent(authStore!.userData.countries);
        this.setState({
          navigationItems: this.structureEventsNavigationItems(this.props.eventStore!.eventList),
        });
        break;
      case 'WHEEL_OF_FORTUNE':
        await this.props.wheelFortuneStore.getWheelEvents();
        this.setState({
          navigationItems: this.structureWheelEventsNavigationItems(this.props.wheelFortuneStore!.events.filter(e => e.isActive))
        })
        break;
      default:
        break;
    }
  };

  structurePartnersNavigationItems = (response: any) => {
    const ItemsList: any[] = [];
    for (const deglawyItem of response) {
      const item = {
        value: deglawyItem.id,
        name: deglawyItem.title,
      };
      ItemsList.push(item);
    }
    return ItemsList;
  };

  structureAcademiesNavigationItems = (response: any) => {
    console.log(response);
    const academyList: any[] = [];
    for (const academy of response) {
      const item = {
        value: academy.academyId,
        name: `${academy.title}`,
      };
      academyList.push(item);
    }
    return academyList;
  };

  structureEventsNavigationItems = (response: any[]) => {
    const currentDate = new Date().getTime();
    const filteredEvents = response
      .filter(event => {
        return event.sendTime >= currentDate;
      }).map(event => {
        return ({
          value: event.eventId,
          name: event.title,
        })
      })
    return filteredEvents;
  }

  structureBranchesNavigationItems = (response: any) => {
    const BranchesList: any[] = [];
    for (const branch of response) {
      const item = {
        value: branch.id,
        name: `${branch.title}`,
      };
      BranchesList.push(item);
    }
    return BranchesList;
  };
  structureWheelEventsNavigationItems = (wheelEvents: WheelEvent []) => {
    const list: {name: string, value: number} [] = [];
    wheelEvents.forEach(event => list.push({value: event.eventId , name: event.title}));
    return list;
  };

  handleEnglishTitleStateChange = (event: any) => {
    this.setState({
      notificationTitleEn: event.target.value,
    });
  };


  handleArabicTitleStateChange = (event: any) => {
    this.setState({
      notificationTitleAr: event.target.value,
    });
  };

  handleEnglishBodyStateChange = (event: any) => {
    this.setState({
      notificationBodyEn: event.target.value,
    });
  };

  handleArabicBodyStateChange = (event: any) => {
    this.setState({
      notificationBodyAr: event.target.value,
    });
  };

  handleLinkStateChange = (event: any) => {
    this.setState({
      link: event.target.value,
    });
  };

  handleNativeScreenStateChange = (event: any) => {
    this.setState({
      nativeModuleName: event.target.value,
    });
  };

  handleNativeMethodStateChange = (event: any) => {
    this.setState({
      nativeModuleMethodName: event.target.value,
    });
  };

  handleAddImageEnToGallery = (prop: any, imageFile: File) => {
    const file = Object.assign(imageFile, {
      preview: URL.createObjectURL(imageFile),
    });
    this.setState({
      imageEn: [file],
    });
  };

  handleAddImageArToGallery = (prop: any, imageFile: File) => {
    const file = Object.assign(imageFile, {
      preview: URL.createObjectURL(imageFile),
    });
    this.setState({
      imageAr: [file],
    });
  };

  handleDeleteImageEnFromGallery = (name: string, imageIndex: number) => {
    this.setState({
      imageEn: [],
    });
  };

  handleDeleteImageArFromGallery = (name: string, imageIndex: number) => {
    this.setState({
      imageAr: [],
    });
  };

  handleAddFile = (prop: any, imageFile: File) => {
    const filePreview = Object.assign(imageFile, {
      preview: URL.createObjectURL(imageFile),
    });

    // convert excel file to csv
    if (imageFile.name.indexOf('.xlsx') >= 0) {
      const reader = new FileReader();
      reader.onload = (entry: ProgressEvent<FileReader>) => {
        /* Parse data */
        const bstr = entry.target!.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = (XLSX.utils.sheet_to_csv as any)(ws, { header: 1 });
        /* Update state */
        this.setState({
          fileData: data,
          file: [filePreview],
        });

      };
      reader.readAsBinaryString(imageFile);
      return;
    }

    const reader = new FileReader();
    reader.readAsText(imageFile);

    reader.onload = (entry: any) => {

      this.setState({
        fileData: entry.target.result,
        file: [filePreview],
      });

    };
  };

  handleDeleteFile = (name: string, imageIndex: number) => {
    this.setState({
      file: [],
    });
  };

  resetState = () => {
    this.setState({
      notificationTitleEn: '',
      notificationBodyEn: '',
      notificationTitleAr: '',
      notificationBodyAr: '',
      status: 'all',
      imageEn: [],
      imageAr: [],
      link: '',
      file: [],
      fileData: '',
      type: 'static',
      internalNavigationItemId: -1,
      internalNavigationType: null,
      navigationItems: [],
      hideTitle: false,
      nativeModuleMethodName: '',
      nativeModuleName: '',
    });
  };

  validateRequiredFields = () => {
    let areValid = !!this.state.notificationTitleEn
    && !!this.state.notificationBodyEn;
    if (this.state.type === NotificationType.INTERNAL) {
      areValid = areValid && !!this.state.internalNavigationType;
      if (!!this.state.internalNavigationType && [
        'offer', 'partner', 'academy', 'branch', 'event', 'trophy', 'WHEEL_OF_FORTUNE',
      ].includes(this.state.internalNavigationType)) {
        areValid = areValid && (this.state.internalNavigationItemId !== -1);
      }
    }
    if (this.state.notificationScheduleType === NotificationScheduleType.SCHEDULE) {
      areValid = areValid && !!this.sendTime;
    } else if (this.state.notificationScheduleType === NotificationScheduleType.BATCHES) {
      areValid = areValid && !!this.batches.length;
    }

    return areValid;
  };

  openConfirmationModal = () =>{
    const allValid = this.validateRequiredFields();
    if (allValid) {
      this.setState({ open: true });
    } else {
      this.setState({ triedToSubmit: true });
      SnackBarComponent.getInstance().openSnackbar('Required fields are missing', 4000, 'error');
    }
  };

  closeConfirmationModal = () => {
    this.setState({open: false});
  };

  handleSubmit = async () => {
    const {
      notificationTitleEn,
      notificationBodyEn,
      notificationBodyAr,
      notificationTitleAr,
      status,
      imageEn,
      imageAr,
      link,
      type,
      internalNavigationType,
      internalNavigationItemId,
      file,
      hideTitle,
      notificationChannel,
      nativeModuleMethodName,
      nativeModuleName,
    } = this.state;

    if (hideTitle && ['external', 'static'].includes(type) && imageEn.length === 0) {
      SnackBarComponent.getInstance().openSnackbar(
        "You can't hide title without adding image",
        4000,
        'error',
      );
      return;
    }
    return new Promise<void>(async (res, rej) => {
      try {
        await this.props.notificationStore.sendNewNotification(
          notificationTitleEn,
          notificationBodyEn,
          notificationTitleAr,
          notificationBodyAr,
          hideTitle,
          status,
          imageEn,
          imageAr,
          file[0],
          link,
          type,
          String(internalNavigationType),
          internalNavigationItemId,
          this.props.countryStore!.managedCountries,
          notificationChannel,
          this.batches,
          this.sendTime,
          nativeModuleMethodName,
          nativeModuleName,
        );
        SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
        }), 4000, 'success');
        this.props.history.goBack();
        res();
      } catch (error) {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 4000, 'error')
        rej();
      }
    })
  };

  async componentDidMount() {
    const {
      countryStore,
    } = this.props;
    await countryStore!.getUserManagedCountries();

    if (countryStore!.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }

    this.setState({
      loadingCountry: false,
    });

  }

  goBack = () => {
    this.props.history.goBack();
  }

  batchesChanged = (notificationBatches: NotificationBatch []) => {
    const isValid = notificationBatches.every(b => b.valid);
    if (!isValid) {
      return;
    }
    this.batches = notificationBatches;
  }

  scheduleChanged = (sendTime: string) => {
    this.sendTime = sendTime;
  };

  render() {
    this.searchFilterDropdown = this.getArticleSearchFilterDropDown();
    this.nativeMethodScreen = this.getNativeMethodScreen();
    this.typeFilterDropDown = this.getTypeFilterDropDown();
    this.channelsTypes = this.getNotficationChannelsTypes();
    this.internalNavigationType = this.getInternalNavigationTypeFilterDropDown();
    this.internalNavigationItemsDropDown = this.getInternalNavigationItemsFilterDropDown();
    const renderItemsDropDown = (this.state.type === 'internal'
      && (this.state.internalNavigationType === 'offer'
        || this.state.internalNavigationType === 'partner'
        || this.state.internalNavigationType === 'branch'
        || this.state.internalNavigationType === 'academy'
        || this.state.internalNavigationType === 'trophy'
        || this.state.internalNavigationType === 'event'
        || this.state.internalNavigationType === 'WHEEL_OF_FORTUNE'
      )
    );
    if (this.state.loadingCountry) {
      return null;
    }
    return (
      <div className={classes.alertContainer}>
        <h2
          className={classes.title}
        >
          Send Notification
        </h2>
        <p>
          Choose the title and body of the notification.
        </p>

        <div className={classes.filterContainer}>
          <div className={classes.search}>
            <SearchFilterDropdown searchFilterDropdown={this.searchFilterDropdown} label={'Audience'} />
          </div>
          <div className={classes.search}>
            <SearchFilterDropdown searchFilterDropdown={this.typeFilterDropDown} label={'Type'} />
          </div>
        </div>

        <SearchFilterDropdown key={0} searchFilterDropdown={this.channelsTypes} label={'Notification Channel'}/>

        <TextField
          onChange={this.handleEnglishTitleStateChange}
          autoFocus
          margin="dense"
          id="titleEnglish"
          label="Title English"
          fullWidth
          autoComplete="off"
          required
          error={this.state.triedToSubmit && this.state.notificationTitleEn === ''}
        />

        <TextField
          onChange={this.handleEnglishBodyStateChange}
          autoFocus
          margin="dense"
          id="bodyEnglish"
          label="Body English"
          fullWidth
          autoComplete="off"
          required
          error={this.state.triedToSubmit && this.state.notificationBodyEn === ''}
        />
      <TextField
          onChange={this.handleArabicTitleStateChange}
          autoFocus
          margin="dense"
          id="titleArabic"
          label="Title Arabic"
          fullWidth
          autoComplete="off"
        />

        <TextField
          onChange={this.handleArabicBodyStateChange}
          autoFocus
          margin="dense"
          id="bodyArabic"
          label="Body Arabic"
          fullWidth
          autoComplete="off"
        />
        {
          this.state.type === NotificationType.EXTERNAL
            ? (
              <TextField
                onChange={this.handleLinkStateChange}
                autoFocus
                margin="dense"
                id="link"
                label="Link"
                fullWidth
              />
            )
            : null
        }
        {
          this.state.type === NotificationType.NATIVE
            ? (
              <>
                <TextField
                  onChange={this.handleNativeScreenStateChange}
                  autoFocus
                  margin="dense"
                  id="nativeModuleName"
                  label="Native Module Name"
                  fullWidth
                />
                <TextField
                  onChange={this.handleNativeMethodStateChange}
                  autoFocus
                  margin="dense"
                  id="nativeModuleMethodName"
                  label="Native Module Method Name"
                  fullWidth
                />
              </>) : null
        }
        {
          this.state.type === NotificationType.INTERNAL
            ? <SearchFilterDropdown
                key={1}
                searchFilterDropdown={this.internalNavigationType}
                label={'Navigation Type'}
                error={this.state.triedToSubmit && this.state.internalNavigationType === null}
                required
              /> : null
              }
        {
          renderItemsDropDown
          ? <SearchFilterDropdown
              key={2}
              searchFilterDropdown={this.internalNavigationItemsDropDown}
              label={'Navigation Item ID'}
              error={this.state.triedToSubmit && this.state.internalNavigationItemId === -1}
              required
            /> : null
        }
        {
          ['external', 'static'].includes(this.state.type) &&
          <FormControlLabel
            control={
              <Switch
                checked={this.state.hideTitle}
                onChange={(event: any) => this.changeShowTitleState(event.target.checked)}
                color="primary"
              />
            }
            label='Hide Title and Body'
          />
        }
        {['external', 'static'].includes(this.state.type)
          ? (
            <>
            <GalleryField
              errors=""
              touched=""
              filedType="GalleryField"
              onAddImage={this.handleAddImageEnToGallery}
              onRemoveImage={this.handleDeleteImageEnFromGallery}
              name="notificationImageEn"
              value={this.state.imageEn}
              accept="image/*"
              size={200}
              label="Notification Image English"
              isLimitToOneImage
              processing={this.props.notificationStore.addLoading}
            />
            <GalleryField
              errors=""
              touched=""
              filedType="GalleryField"
              onAddImage={this.handleAddImageArToGallery}
              onRemoveImage={this.handleDeleteImageArFromGallery}
              name="notificationImageAr"
              value={this.state.imageAr}
              accept="image/*"
              size={200}
              label="Notification Image Arabic"
              isLimitToOneImage
              processing={this.props.notificationStore.addLoading}
            />
            </>
          ) : null}
        {this.state.status === 'group'
          ? (
            <GalleryField
              errors=""
              touched=""
              filedType="GalleryField"
              onAddImage={this.handleAddFile}
              onRemoveImage={this.handleDeleteFile}
              name="notificationImage"
              value={this.state.file}
              label="Notification File"
              isLimitToOneImage
              processing={this.props.notificationStore.addLoading}
            />
          ) : null}
        <FormControl component="span">
          <RadioGroup
            value={this.state.notificationScheduleType}
            onChange={(e) => this.setState({
              notificationScheduleType: e.target.value as NotificationScheduleType,
            })}
          >
            <FormControlLabel value={NotificationScheduleType.NOW} control={<Radio />} label={NotificationScheduleType.NOW} />
            <FormControlLabel value={NotificationScheduleType.SCHEDULE} control={<Radio />} label={NotificationScheduleType.SCHEDULE} />
            <FormControlLabel value={NotificationScheduleType.BATCHES} control={<Radio />} label={NotificationScheduleType.BATCHES} />
          </RadioGroup>
        </FormControl>
        {
          this.state.notificationScheduleType === NotificationScheduleType.BATCHES && (
            <NotificationBatches
              batchesChanged={((batches) => this.batchesChanged(batches))}
              error={this.state.triedToSubmit && !this.batches.length}
            />
          )
        }
        {
          this.state.notificationScheduleType === NotificationScheduleType.SCHEDULE && (
            <NotificationSchedule
              handleChange={((sendTime) => this.scheduleChanged(sendTime))}
              error={this.state.triedToSubmit && !this.sendTime}
            />
          )
        }
        <div
          className={classes.actionContainer}
        >
          <Button onClick={() => this.goBack()} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => this.openConfirmationModal()}
            color="primary"
          >
            {this.props.notificationStore.addLoading ? <CircularProgress /> : 'Send'}
          </Button>
        </div>
        <ConfirmNotification
          open={this.state.open}
          titleEn= {this.state.notificationTitleEn}
          bodyEn={this.state.notificationBodyEn}
          titleAr={this.state.notificationTitleAr}
          bodyAr={this.state.notificationBodyAr}
          status={this.state.status}
          type={this.state.type}
          link= {this.state.link}
          imageEn= {this.state.imageEn}
          imageAr={this.state.imageAr}
          internalNavigationType={ this.state.internalNavigationType}
          fileData= {this.state.fileData}
          file={this.state.file}
          channelId={this.state.notificationChannel}
          hideTitle={this.state.hideTitle}
          nativeModuleMethodName={this.state.nativeModuleMethodName}
          nativeModuleName={this.state.nativeModuleName}
          handleSend={this.handleSubmit}
          handleClose={this.closeConfirmationModal}
          processing={this.props.notificationStore.addLoading}

        />
      </div>
    );
  }
}

export default AddNotification;
